import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray, FormGroupDirective, NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';
import { ConfirmModalComponent } from '..';

// export class MyErrorStateMatcher implements ErrorStateMatcher {
//     isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
//       const isSubmitted = form && form.submitted;
//       return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
//     }
//   }

@Component({
    selector: 'creditcard-confirmation-modal',
    templateUrl: './creditcard-confirmation.component.html',
    styleUrls: ['./creditcard-confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreditcardConfirmationModalComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() message: string;
    @Input() confirmationData: any;

    creditcardConfirmation: FormGroup;
    confirm: any;
    isFoundationTrustee = false;
    type = "";

    constructor(
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<CreditcardConfirmationModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private fb: FormBuilder,
        private _dataService: LGEDataService,
        private ref: ChangeDetectorRef,
    ) {
        this.title = data.title;
        this.message = data.message;
        this.confirmationData = data.confirmationData;
        this.isFoundationTrustee = this.title === 'Pay As Foundation Trustee Credit Card';
        let reqNumber = data.confirmationData.requestNumber;
        if (reqNumber.includes("CG") || reqNumber.includes("PP")) {
            this.type = "project";
        } else if (reqNumber.includes("ES")) {
            this.type = "event";
        }
    }

    public showConfirm(title: string, message: string) {
        this.confirm = this.dialog.open(ConfirmModalComponent, {
            width: '350px',
            disableClose: false,
            data: { title: title, message: message }
        });
    }

    ngOnInit() {
        this.createForms();
    }

    createForms(): void {
        this.creditcardConfirmation = this.fb.group({
            formccId: [''],
            requestNumber: [''],
            requestName: [''],
            confirmationNoCC: ['', [Validators.required, Validators.maxLength(20)]]
        });
        this.creditcardConfirmation.setValue(this.confirmationData);
    }

    onSave() {
        if (this.isFoundationTrustee) {
            this.dialogRef.close(this.creditcardConfirmation.value);
        } else {
            this.showConfirm('Are you sure you want to save?', '');
            this.confirm.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    // // console.log(this.creditcardConfirmation.value)
                    this.dialogRef.close(this.creditcardConfirmation.value);
                }
            });
        }
    }

    onNoClick(): void {
        if (this.isFoundationTrustee) {
            this.dialogRef.close('Skip');
        } else {
            this.showConfirm('Are you sure you want to cancel?', '');
            this.confirm.afterClosed().subscribe(result => {
                if (result === 'yes') {
                    this.dialogRef.close()
                }
            });
        }
    }

    ngOnDestroy() {

    }

}

